"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.permissions = exports.Permission = void 0;
var Permission;
(function (Permission) {
    Permission["AgeGroupsRead"] = "age-groups:read";
    Permission["AgeGroupsWrite"] = "age-groups:write";
    Permission["ChildAttendanceRead"] = "child-attendance:read";
    Permission["ChildAttendanceWrite"] = "child-attendance:write";
    Permission["ChildRead"] = "child:read";
    Permission["ChildWrite"] = "child:write";
    Permission["ContactPersonRead"] = "contact-person:read";
    Permission["ContactPersonWrite"] = "contact-person:write";
    Permission["ConsumableRead"] = "consumables:read";
    Permission["ConsumableWrite"] = "consumables:write";
    Permission["ConsumptionRead"] = "consumption:read";
    Permission["ConsumptionWrite"] = "consumption:write";
    Permission["CrewAttendanceRead"] = "crew-attendance:read";
    Permission["CrewAttendanceWrite"] = "crew-attendance:write";
    Permission["CrewMemberRead"] = "crew-member:read";
    Permission["CrewMemberWrite"] = "crew-member:write";
    Permission["DiscountRead"] = "discounts:read";
    Permission["DiscountsWrite"] = "discounts:write";
    Permission["ReportsDelete"] = "reports:delete";
    Permission["ReportsRead"] = "reports:read";
    Permission["ReportsRequest"] = "reports:request";
    Permission["ShiftPresetRead"] = "shift-preset:read";
    Permission["ShiftPresetWrite"] = "shift-preset:write";
    Permission["ShiftRead"] = "shift:read";
    Permission["ShiftWrite"] = "shift:write";
    Permission["TemplateFillIn"] = "template:fill-in";
    Permission["TemplateRead"] = "template:read";
    Permission["TemplateWrite"] = "template:write";
    Permission["TenantAddMember"] = "tenant:add-member";
    Permission["TenantListMembers"] = "tenant:list-members";
    Permission["TenantRemoveMember"] = "tenant:remove-member";
    Permission["TenantWrite"] = "tenant:write";
})(Permission = exports.Permission || (exports.Permission = {}));
exports.permissions = Object.keys(Permission).map(key => Permission[key]);
//# sourceMappingURL=permission.js.map